import { formatify } from "./formatify.js";

export function formatifyHtml(root: HTMLElement): string {
	for (const child of root.childNodes) {
		if (child.nodeType === 3) {
			if (child.nodeValue?.trim()) {
				const parent = child.parentNode as HTMLElement;
				const replacement = document.createElement("span");
				parent.insertBefore(replacement, child);
				parent.removeChild(child);
				const formatted = formatify(child.nodeValue);
				if (formatted.trim() !== "") {
					replacement.outerHTML = formatted;
				}
			}
		} else if (child.nodeType === 1) {
			const node = child as HTMLElement;
			node.innerHTML = formatifyHtml(node);
		}
	}
	return root.innerHTML;
}
